module.exports = __webpack_public_path__ + "img/newPeoplebeijing.4b9b19f9.png";